import api from '../..'

const foldersList = () => {
  return api.get('/administration/folders').then(({ data }) => {
    return {
      data: data.data.map(({ attributes }: any) => attributes),
    }
  })
}

export default foldersList
